// web环境 jsonp请求
// 注意axios版本要保持0.18.x版本 否则axios-jsonp不能正常工作过
import axios from 'axios';
import jsonpAdapter from 'axios-jsonp';
import { baseURL, tenantId } from './commonParams';

const getAxiosJsonp = (baseURL, url, params) => {
  const axiosJsonp = axios.create({
    baseURL: baseURL, // api 的 base_url
    timeout: 15000, // 请求超时时间
    adapter: jsonpAdapter,
    withCredentials: true,
    callbackParamName: 'callback'
  });
  // request拦截器
  axiosJsonp.interceptors.request.use(
    (config) => {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      config.params.tenantId = config.params.tenantId || tenantId;
      // auth改造 代驾接口增加参数domainType=200
      config.params.domainType = 200;
      return config;
    },
    (error) => {
      // Do something with request error
      Promise.reject(error);
    }
  );

  // response 拦截器
  axiosJsonp.interceptors.response.use(
    (response) => {
      console.log('response', response);
      return response.data;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  return new Promise((resolve, reject) => {
    axiosJsonp(url, params)
      .then((res) => {
        return resolve(res);
      })
      .catch((error) => {
        return reject(error);
      });
  });
};
export default function (url, params) {
  return new Promise((resolve, reject) => {
    return getAxiosJsonp(baseURL, url, params)
      .then((res) => {
        return resolve(res);
      })
      .catch((error) => {
        return reject(error);
      });
  });
}
